import { useNavigate } from "react-router-dom";
import useSignIn from "../../froms/hooks/useSignIn";
import SignInForm from "../../froms/signInUser";
import { useEffect } from "react";
import { PATHS } from "../../../../../shared/constants";

interface ISingIn {
  onClose?: () => void;
}

const SingIn = ({ onClose }: ISingIn) => {
  const { handleSignIn, handleChange, signInData, token } = useSignIn();

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      if (onClose) {
        onClose();
      } else {
        navigate(`/${PATHS.myPersonal}`);
      }
    }
  }, [token]);

  return (
    <SignInForm
      data={signInData}
      isDisable={!Boolean(signInData.numberPhone && signInData.otp)}
      onChange={handleChange}
      onSendData={handleSignIn}
    />
  );
};

export default SingIn;
